export default {
  mounted () {
    this.$recaptcha.init().catch(this.$debug.log)
  },

  beforeDestroy () {
    this.$recaptcha.destroy()
  }
}
